import { useBreakpointRange, constants, useWindowSize } from "@newsela/angelou";

import useViewportIsNotDesktop from "@/view/utils/useViewportIsNotDesktop";

const {
  breakpoints: { BreakpointRanges },
} = constants;

const defaultToolbarMaxHeight = 576;
const studentToolbarMaxHeight = 360;
const toolbarPadding = 30;
const stickyBarHeight = 93;
const activitiesPanelButtonHeight = 80;

// Because the secondary actions toolbar is sticky, it cannot be scrolled. As such, we need
// to consider the window height when deciding whether to show the toolbar or mobile actions.
const getIsViewportTooShort = (
  isStudent,
  activitiesPanelIsAtBottomOfPage,
  height,
) => {
  const maxToolbarHeight = isStudent
    ? studentToolbarMaxHeight
    : defaultToolbarMaxHeight;
  const spaceRequiredForToolbar =
    maxToolbarHeight + toolbarPadding + stickyBarHeight;

  if (activitiesPanelIsAtBottomOfPage) {
    return height < spaceRequiredForToolbar + activitiesPanelButtonHeight;
  }

  return height < spaceRequiredForToolbar;
};

const useShouldShowMobileActions = (isStudent) => {
  const currentViewportRange = useBreakpointRange();
  const { height } = useWindowSize();
  const activitiesPanelIsAtBottomOfPage = useViewportIsNotDesktop();

  const isMobile = [
    BreakpointRanges.zeroToXs,
    BreakpointRanges.xsToSm,
  ].includes(currentViewportRange);
  if (isMobile) return true;

  const viewportIsTooShort = getIsViewportTooShort(
    isStudent,
    activitiesPanelIsAtBottomOfPage,
    height,
  );
  return viewportIsTooShort;
};

export default useShouldShowMobileActions;
